<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">ПКФО-2</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="table-container">
            <table class="table b-table table-bordered b-table-no-border-collapse">
                <thead class="sticky-thead">
                <tr>
                    <th v-for="(field, index) in tableFields" class="text-center" :key="index"
                        :rowspan="field.rowspan || 1" :colspan="field.colspan || 1"
                        :style="{ width: index === 0 ? '800px' : index === 2 ? '200px' : '' }"
                        v-html="field.key === 'evaluation' ? getEvaluationLabel() : field.label">
                    </th>
                </tr>
                <tr>
                    <th v-for="year in forecastYears" class="text-center" :key="year">{{ year }}</th>
                </tr>
                </thead>
                <tbody v-for="(row, index) in formPkfo2" :key="index" class="table-info"
                       :style="{
                        backgroundColor:
                          row.line_code.endsWith('0') && (parseInt(row.line_code) <= 200 || row.line_code === '300')
                            ? (row.line_code.endsWith('00') ? '' : '#e8f4fa')
                            : 'white'
                      }">
                <tr>
                    <td>{{ row.name_ru}}</td>
                    <td class="text-center">{{ row.line_code }}</td>
                    <td class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'fact')"
                            :title="hasError(row.line_code, 'fact').text"
                            class="warning-icon"
                        >⚠</span>
                        <span v-if="row.fact">{{ $n(toNum(row.fact)) }}</span>
                    </td>
                    <td class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'evaluation')"
                            :title="hasError(row.line_code, 'evaluation').text"
                            class="warning-icon"
                        >⚠</span>
                        <span v-if="row.evaluation">{{ $n(toNum(row.evaluation)) }}</span>
                    </td>
                    <td class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'forecast_1')"
                            :title="hasError(row.line_code, 'forecast_1').text"
                            class="warning-icon"
                        >⚠</span>
                        <span v-if="row.forecast_1">{{ $n(toNum(row.forecast_1)) }}</span>
                    </td>
                    <td class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'forecast_2')"
                            :title="hasError(row.line_code, 'forecast_2').text"
                            class="warning-icon"
                        >⚠</span>
                        <span v-if="row.forecast_2">{{ $n(toNum(row.forecast_2)) }}</span>
                    </td>
                    <td class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'forecast_3')"
                            :title="hasError(row.line_code, 'forecast_3').text"
                            class="warning-icon"
                        >⚠</span>
                        <span v-if="row.forecast_3">{{ $n(toNum(row.forecast_3)) }}</span>
                    </td>
                </tr>
                </tbody>
            </table>
            <loading
                :active="loading"
                is-full-screen
                spinner="bar-fade-scale"
                color="#6495ED"
            />
        </div>
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import {Ax} from "@/utils";

export default {
    name: 'forecast-pkfo2',
    components: {
        'loading': VueElementLoading
    },
    props: {
        year: Number,
        region: String,
        version: String,
        abp: Number,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            open: false,
            tableFields: [
                {
                    key: 'name_ru',
                    label: 'Показатели',
                    rowspan: 2
                },
                {
                    key: 'line_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: 'Факт, ТЫС.ТЕҢГЕ',
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: 'Оценка*, ТЫС.ТЕҢГЕ',
                    rowspan: 1
                },
                {
                    key: 'forecast',
                    label: 'Прогноз, ТЫС.ТЕҢГЕ',
                    colspan: 3
                }],
            formPkfo2: [],
            repdate: null,
            openRows: {},
            inputValues: []

        }
    },
    async mounted() {
        await this.LoadPKFO2();
    },
    computed: {
        forecastYears() {
            return [this.year - 2, this.year - 1, this.year, this.year + 1, this.year + 2];
        }
    },
    methods: {
        hasError(lineCode, field) {
            return this.checkDataList.find(item =>
                item.checked_form === 'pkfo2' &&
                String(item.checked_line_code) === String(lineCode) &&
                item[field]
            );
        },
        getEvaluationLabel() {
            if (!this.repdate) {
                return `Оценка*, тыс.теңге`;
            }
            return `<span title="Оценочные данные\nактуальны на дату:\n${this.formatDate(this.repdate)}"
                style="cursor: pointer;">Оценка*, тыс.теңге</span>`;
        },
        formatDate(date) {
            if (date !== null){
                return new Date(date).toLocaleDateString('ru-RU', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
            }
        },
        async LoadPKFO2() {
            this.loading = true;
            try {
                const response = await fetch(`/api-py/get_dict_items_pkfo2/` + this.version + '/' + this.abp + '/' + this.year + '/' + this.obl + '/' + this.region);
                if (response.status === 200) {
                    const data = await response.json();
                    this.formPkfo2 = data.result;
                    this.repdate = data.repdate;
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка ПКФО-2', error.toString());
            }
            this.loading = false;
        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.year, region: this.region, version: this.version, abp: this.abp, data_type: this.dataType, reg_name: this.region_name, ver_name: this.version_name, obl: this.obl };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_download_pkfo_2/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'ПКФО-2.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        toggleRow(index) {
            this.$set(this.openRows, index, !this.openRows[index]);
        },
        toNum(value, fix = 1) {
            if (typeof (value) === 'string') {
                return parseFloat(parseFloat(value).toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
    }
}
</script>